/*
 * Jira Ticket:
 * Created Date: Thu, 16th Apr 2020, 15:54:47 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const createEmploymentMutation = gql`
  mutation createEmployment(
    $organisationId: ID!
    $projectIds: [ID!]
    $type: EmploymentType!
    $role: OrganisationRole!
    $emails: [EmailAddress!]!
  ) {
    data: createEmployment(
      organisationId: $organisationId
      projectIds: $projectIds
      type: $type
      role: $role
      emails: $emails
    ) {
      id
    }
  }
`;

export default ({ client, params }) => {
  try {
    return client.mutate({
      mutation: createEmploymentMutation,
      variables: {
        ...params,
      },
    });
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
